
import deepMerge from '../utils/deepMerge';

export const UPDATE_STATE = 'UPDATE_STATE';

const updateState = (state, payloadObjOrFn) => {
  const payload =
    payloadObjOrFn && typeof payloadObjOrFn === 'function'
      ? payloadObjOrFn(state)
      : payloadObjOrFn;
  if (!payload || payload === state) {
    return state;
  }
  return deepMerge(state, payload);
};

export default updateState;
